export const REPORTCOMPAREPERIOD_STARTDATE = 'REPORTCOMPAREPERIOD_STARTDATE';
export const REPORTCOMPAREPERIOD_ENDDATE = 'REPORTCOMPAREPERIOD_ENDDATE';
export const REPORTCOMPAREPERIOD_STARTDATE2 = 'REPORTCOMPAREPERIOD_STARTDATE2';
export const REPORTCOMPAREPERIOD_ENDDATE2 = 'REPORTCOMPAREPERIOD_ENDDATE2';